export default __webpack_public_path__ + "static/af-cd5bccc308615b238cd104546b2f0e1a.svg";